import SelectPlayer from "./SelectPlayer";
export default SelectPlayer;
